module.exports = __webpack_public_path__ + "img/refferal-img.c8ad9108.svg";